import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

import * as Sentry from "@sentry/react";
import { BrowserTracing } from "@sentry/tracing";

console.log("environment: ", process.env.NODE_ENV);

Sentry.init({
  environment: process.env.NODE_ENV,
  dsn: "https://3a9835b9f7564e43a2488c5cbb1977ef@o1120203.ingest.sentry.io/6270046",
  integrations: [new BrowserTracing()],
  tracesSampleRate: 1.0,
});

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
